// extracted by mini-css-extract-plugin
export default {"Stack":"FlqmEfJa","Spacer":"_BJFYP0A"};